import script from "./ChatSidebarManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarManagement.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarManagement.vue?vue&type=style&index=0&id=1a039372&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a039372"]])

export default __exports__